import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { XsI18nPipe } from '@nx-fe/pipes';
import { DeviceService } from '@nx-fe/services';
import {IMcSendScript, RcDeviceService} from 'xsmodules/remote-control/services/rc-device-service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-rc-execute-script',
  templateUrl: './rc-execute-script.component.html',
  styleUrls: ['./rc-execute-script.component.scss'],
})
export class RcExecuteScriptComponent implements OnInit, OnDestroy {
  public currentScript: string;
  public deviceId: string;
  public selectList: any[];
  public selectedItem: any;
  public deviceActionScriptList: IMcSendScript[] = [];
  unsubscribe$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<RcExecuteScriptComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { deviceId: string; mcConnectionId: number },
    private xsI18nPipe: XsI18nPipe,
    private deviceService: DeviceService,
    private rcDeviceService: RcDeviceService
  ) {}

  ngOnInit(): void {
    this.deviceId = this.data.deviceId;
    this.rcDeviceService
      .getDeviceActionScript(this.data.mcConnectionId ? this.data.mcConnectionId : 0)
      .subscribe(sendScripts => {
        this.deviceActionScriptList = sendScripts;
        this.selectList = [{ id: '1', caption: this.xsI18nPipe.transform('sendScript_OneTimeScript'), italic: true }];
        this.selectedItem = this.selectList[0];

        for (const scriptItem of this.deviceActionScriptList) {
          this.selectList.push({
            id: scriptItem.id,
            caption: scriptItem.name,
          });
        }
      });
  }

  public onSelectItem = (item: any) => {
    this.selectedItem = item;
    this.currentScript = this.getScriptFromId(item.id);
  };

  send() {
     this.rcDeviceService.sendDeviceScript(this.deviceId, this.currentScript);
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  cancel() {
    this.dialogRef.close();
  }

  public isDisabled = (): boolean =>
    this.currentScript === null || this.currentScript === undefined || this.currentScript === '';

  private getScriptFromId = (id: string) => {
    const scriptItem = this.deviceActionScriptList.find(script => script.id === id);
    if(scriptItem) {
      return scriptItem.content;
    }
  };
}
